export const AU_CAMPAIGN_ID = 'autodesk-university-2026';
export const AU_PASS_CODE = '7KQ-M4V';
export const ENTERPRISE_PASS_STATUS = 'enterprise_pass';

export function normalizePassCode(code: string): string {
  return code.trim().toUpperCase().replace(/[\s-]/g, '');
}

export function canRedeemPass(
  campaign: {
    isEnabled: boolean;
    redeemUntil: Date;
    code: string;
  },
  code: string,
  now: Date,
): boolean {
  return (
    campaign.isEnabled &&
    now < campaign.redeemUntil &&
    normalizePassCode(code) === normalizePassCode(campaign.code)
  );
}

export class EnterprisePassError extends Error {}
